/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IBed } from 'app/shared/model/bed.model';
import { IAdmission } from 'app/shared/model/admission.model';
import { BedAllotmentType } from 'app/shared/model/enumerations/bed-allotment-type.model';
import { BedReleaseType } from 'app/shared/model/enumerations/bed-release-type.model';

export interface IBedAllotment {
  id?: string;
  allotmentDate?: number | null;
  releaseDate?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  active?: boolean | null;
  allotmentNotes?: string | null;
  allotmentType?: keyof typeof BedAllotmentType | null;
  releaseType?: keyof typeof BedReleaseType | null;
  bed?: IBed;
  admission?: IAdmission | null;
}

export const defaultValue: Readonly<IBedAllotment> = {
  active: false,
};
